<template>
	<div class="Index">
		<div class="search">
			<router-link :to="{path:'/personal/index'}" class="avatar">
				<img :src="userInfo.avatar" alt="">
			</router-link>
			<div class="search-input">
				<van-icon name="search" />
				<input type="text" placeholder="请输入搜索关键词" @focus="goSearch">
			</div>
			<!-- <div   class="attentiontBtn" @click="followChannel">{{followText}}</div> -->
		</div>
		<div class="swiper-img">
			<img :src="bannerImg" alt="" v-if="bannerImg">
		</div>
		<div class="articles">
			<van-tabs v-model="active" color="#2880BB" title-inactive-color="#999" title-active-color="#333"  @change="changeTab">
				<van-tab :title="item.name"  v-for="(item,index) in channelsList" :key="index">
					<div class="content">
						<div class="titleWrap">
							<div class="title" v-for="(val,ind) in item.son" :key="val.id" :class="sonactive==ind?'active':''" @click="changeTitle(ind,val.id)">
									{{val.name}}
							</div>
							<span class="uppertrian" ref="uppertrian" :style="{transform:sonactive==0?'translate(-75%,-50%)':'translate(-25%,-50%)'}"></span>
						</div>
						<div class="list">
							<row-item-list :list="articlesList"></row-item-list>
						</div>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>
<script>
	import Banner from "../../components/Banner.vue";
    import Tabbar from '../..//components/Tabbar.vue';
    import RowItemList from "../../components/RowItemList.vue"
    import {InformationMenu,InformationDetails,PersoanalUserInfo} from "../../config/interface.js"
	export default{
		components:{
			Banner,
    		Tabbar,
    		RowItemList
		},
		data(){
			return{
				userInfo:{},     //用户信息
				followText:'关注',
				isEmpty:false,   //列表数据是否为空
				bannerImg:'',    //轮播图
				active:0,           //tabbar的index
				sonactive:1,        //title默认的index
				articlesList:[],   //文章列表
				channelsList:[],           //频道列表
				channel_id:62,         //频道id
				sonChannel_id:0,      //子频道id
				aloading:false,//加载状态
				finished:false,//是否加载
				error:false,//是否出错
			}
		},
		beforeRouteEnter(to, from, next) {
            //  修复iOS版微信HTML5 History兼容性问题
            if (to.path !== location.pathname) {
                //console.log("检测完成")
                // 此处不可使用location.replace
                location.assign(to.fullPath)
            } else {
                next()
            }
        },
		mounted(){
			this.active=0;
			document.title='指南/共识';
			 if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){
					this.getUserInfo();
                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
		},
		methods:{
			//跳转专栏详情
			skipColumnDetails(id){
				this.$router.push({
					path:'/column/details',
					query:{
						id:id
					}
				})
			},
			//频道目录
			getChannels(){
				const url=InformationMenu;
				let params={
					channel_id:this.channel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.channelsList=res.data;
                        this.sonChannel_id=res.data[0].son[1].id;   
						this.bannerImg=this.channelsList[0].image;
						this.getlist();
					}
				})
			},
			//得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo&&this.userInfo.mobile_status==1){
							this.getChannels();
							// if(common.is_weixin()){
							// 	common.wxShare(document.title,'【血管资讯】','cdn.edstatic.com/203012120000/bca5bbcde6b65142646518943d71936a/2020/09/8e44215d-f687-4be7-8ced-81c3c880587a.png');
							// }
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                 this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            })
					        })	
                        }
                    }
                })
            },
			//去搜索
			goSearch(){
				this.$router.push({path:'search/search'})
			},
			//列表
			getlist(){
				const url=InformationDetails;
				let params={
					channel_id:this.sonChannel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						this.articlesList=data.articles;
						this.isEmpty=data.articles.length==0?true:false;
						let my_favorites=data.my_favorites;
						this.articlesList.forEach((item,index)=>{
							item.release_at=item.release_at==null?'':common.splitString(item.release_at,' ',0);
							this.$set(item,'isCollect',my_favorites[item.id]);
						})

					}
				})
			},
			//切换tab标签时触发
			changeTab(index,title){
				this.sonChannel_id=this.channelsList[index].son[1].id;
				this.sonactive=1;
				this.bannerImg=this.channelsList[index].image;
				this.getlist();
				// this.page=1;
				// this.articlesList=[];
				// this.onLoad(this.page);
				
			},
			//切换标题
			changeTitle(index,id){
				this.sonactive=index;
				this.sonChannel_id=id;
				this.getlist();
				// this.page=1;
				// this.articlesList=[];
				// this.onLoad(this.page);
			},
			loadMore(){
				this.page=this.page+1;
				if(this.page==1){
					this.onLoad(this.page);
				}
				else{
					setTimeout(()=>{
						this.onLoad(this.page);
					},500);
				}
				
			},
			onLoad(page) {
				const url=InformationDetails;
				let params={
					paged:1,
					page:page,
        			limit:this.limit,
					channel_id:this.sonChannel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.aloading=false;
						var data=res.data;
						if(page==1){
							this.articlesList=data.articles.data;
						}
						else{
							if(page>1&&this.articlesList.length>0){
								this.articlesList=this.articlesList.concat(data.articles.data);
							}
						}
						this.isEmpty=data.articles.data.length==0?true:false;
						let my_favorites=data.my_favorites;
						for(let i=0;i<this.articlesList.length;i++){
							this.articlesList[i].release_at=this.articlesList[i].release_at==null?'':common.splitString(this.articlesList[i].release_at,' ',0);
							this.$set(this.articlesList[i],'isCollect',my_favorites[this.articlesList[i].id]);
						}
						// this.articlesList.forEach((item,index)=>{
						// 	item.release_at=item.release_at==null?'':common.splitString(item.release_at,' ',0);
						// 	this.$set(item,'isCollect',my_favorites[item.id]);
						// })
						if(this.page>=data.articles.last_page){
							this.finished=true;
						}
						else{
							this.finished=false;
						}

					}
					else{
						this.error=true;
						common.toast(res.code,1000);
					}
				}).catch((err)=>{
                    common.toast(JSON.stringify(err),1000);
                })
        
      }
		}
	}
</script>
<style lang="scss">
	.Index{
		//轮播
		.swiper-img{
			margin:0 auto;
			padding:0px 12px;
			/*width:350px;*/
			box-sizing:border-box;
			.van-swipe-item{
				img{
					width:100%;
					/*height:150px;*/
					border-radius:5px;
				}
			}
		}
		.test{
			margin: 0;

		}
		/*动画*/
		.rotate-active{
			animation: rotate-in 1s;
		}
		@keyframes rotate-in{
			0%{
				transform: rotate(0);
			}
			100%{
				transform: rotate(360deg);
			}
		}
		/*搜索*/
		.search{
			padding:8px 12px;
			@include flex(row);
			align-items:center;
			justify-content:space-between;
			.avatar{
				img{
					width:35px;
					height:35px;
					border-radius:100%;
				}

			}
			.search-input{
				@include flex(row);
				align-items:center;				
				flex:1;
				background: #F2F2F2;
				border: 1px solid #BFBFBF;
				border-radius: 16px;
				height:35px;
				padding:0px 5px;
				padding-left:10px;
				margin:0 8px;
				i{
					font-size:20px;
					color:#999;
				}
				input{
					flex:1;
					font-size:14px;
					color:#999;
					height:100%;
					padding-left:10px;
					background:transparent;
					border:0px;
				}
			}
			.attentiontBtn{
				width: 62px;
				height:35px;
				line-height:35px;
				font-size:14px;
				color:#fff;
				text-align: center;
				background: #FF504F;
				border-radius: 35px;
				border-radius: 35px;
			}
		}
		/*轮播图*/
		.swiper-img{
			img{
				border-radius:5px;
				width:100%;
				height:100%;
			}
		}
		.head{
			height:50px;
			line-height:50px;
			h3{
			font-size: 17px;
			color: #090909;
			letter-spacing: 0.6px;
			}	
		}
		.articles{
			.van-ellipsis{
				font-size:15px;
			}
			.van-tabs__nav{
				position: relative;
				z-index:6;
			}
			.content{
				width:94%;
				margin:18px auto;
				background: #FFFFFF;
				box-shadow: 0 0 9px 0 rgba(0,0,0,0.15);
				.titleWrap{
					position:relative;
					height:45px;
					line-height:45px;
					clear: both;
					div{
						float:left;
						width:56%;
						font-weight: bold;
    					letter-spacing: 1px;
						font-size:15px;
						text-align:center;
						background:#f4f4f4;
					}
					div.active{
						width:44%;
						background:#fff;
					}
					.uppertrian{
							position:absolute;
							left:50%;
							top:0;
							border-style: solid;
							border-color:transparent transparent #fff;
							border-width:45px;
							transform: translate(-75%,-50%);
    						z-index: 3;
						}
					div.active{
						background:#fff;
						color:#333	
					}
					
				}
				.list{
					height:410px;
					overflow: auto;
				}
			}
		}
		.van-overlay{
			display:block;
			z-index:100;
			.tip{
				width: 70%;
				position: absolute;
				right: 20px;
				top: 0;
			}
			.know{
				width:120px;
				position: absolute;
				bottom: 50px;
				left:50%;
				transform: translate(-50%,0);
				width:130px;
				
			}
		}

	}
</style>


// WEBPACK FOOTER //
// src/pages/Guide/newIndex.vue